var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright"},[_c('van-divider',{style:({fontSize: '13px', fontWeight: 600, color: '#D3D5DD'}),attrs:{"content-position":"center"}},[_c('span',[_vm._v("金贵让一切更简单")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }